<template>
  <v-navigation-drawer
      class="bg_light"
        light
        v-model="show"
        width="236"
        app
        permanent
        expand-on-hover
        clipped
        mini-variant
        v-bind:value="minimize"
  >
<!--    Todo: minimize drawer after click -->
<!--    :clipped="$vuetify.breakpoint.lgAndUp"-->
<!--    :mini-variant.sync="mini"-->

    <template v-slot:prepend>
      <v-list-item link @click="$router.push('/menu')" style="background-color: white; padding: 5px; margin: 10px 5px;
      border-radius:10px; height: 50px;" class="d-flex justify-center">
          <img :src="logoUrl" height="100%" style="max-height: 36px;">
      </v-list-item>
    </template>

    <v-list class="mt-10">
      <template v-for="item in items">
        <v-list-item :key="item.text" :to="item.link" v-if="!item.children">
            <v-list-item-icon class="mr-5">
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
          <v-list-item-title :to="item.link" class="font-m font-weight-medium">{{ item.text
            }}</v-list-item-title>
        </v-list-item>
        <v-list-group v-else :key="item.text" no-action>
          <template v-slot:activator>
            <v-list-item-icon class="mr-5">
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="font-m font-weight-medium">{{ item.text }}</v-list-item-title>
          </template>

          <v-list-item v-for="(child, index) in item.children" :key="index" :to="child.link">
            <v-list-item-title class="font-m font-weight-medium child-text">&nbsp;{{ child.text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </template>
          
    </v-list>
    <template v-slot:append>
      <v-list-item link @click="goToSupport()">
        <v-list-item-icon class="mr-5">
          <v-icon>mdi-face-agent</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="font-m font-weight-medium">Hilfe</v-list-item-title>
      </v-list-item>
      <v-list-item link @click="$emit('logout')">
        <v-list-item-icon class="mr-5">
          <v-icon>mdi-logout-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="font-m font-weight-medium">Abmelden</v-list-item-title>
      </v-list-item>
      <v-divider/>
      <v-list-item class="px-2">
        <v-list-item-avatar>
          <v-avatar
            :color="currentUser.iconColor"
            size="56"
            style="color: white"
          ><span class="font-weight-bold">{{initials}}</span></v-avatar>
        </v-list-item-avatar>
        <v-list-item-title class="font-s font-weight-bold">{{currentUser.fullName}}</v-list-item-title>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>

export default {
  data: () => ({
    logoUrl: require('@/assets/motiverse_symbol.png'),
    dialog: false,
    drawer: null,
    items: [
      { text: "Start", link: "/menu", icon: "mdi-home" },

      /* { text: "Modellierungsfragen", link: "/modelQuestions"}, */
    ],
    mini: true,
  }),
  
  props: {
    value: Boolean,
    minimize: Boolean
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    clientIcon(){
      return this.$store.state.clientIcon;
    },
    initials(){
      if(this.currentUser != null && this.currentUser.firstName != null){
        let initials = this.currentUser.firstName.substring(0,1)+this.currentUser.lastName.substring(0,1);
      return initials;
      }
      return "";
    }
  },
  async mounted(){
    
    let userIsAdmin = await this.$store.dispatch('hasPermission', 'ADMIN');
    if(!userIsAdmin) userIsAdmin = await this.$store.dispatch('hasPermission', 'SUPER_ADMIN');
    let hasProcessPermission = await this.$store.dispatch('hasPermission', 'PROCESS');
    let hasSurveyPermission = await this.$store.dispatch('hasPermission', 'SURVEY');

    if(userIsAdmin || hasProcessPermission){
        this.items.push(
          { text: "Prozesse", link: "/processList", icon: "mdi-sitemap-outline", children: [
          { text: "Prozessliste", link: "/processList", icon: "mdi-sitemap-outline"},
          {text: "Prozesssteckbriefe", link: "/processCharacteristic"},
          { text: "Prozesslandkarte", link: "/processMap", icon: "mdi-map-legend"},
          {text: "Prozessobjekte", link: "/contextItems"},
         ] }
      );
      
    }
    if(userIsAdmin || hasSurveyPermission){
      this.items.push(
        { text: "Process Experience", link: "/pxAdmin", icon: "mdi-format-list-checks",
        children: [
          {text: "Fragen", link: "/manageQuestions"},
          {text: "Umfragen", link: "/surveys"},
         ] }
      );
    }
    if(userIsAdmin){
      this.items.push({
        text: "Nutzerverwaltung", 
        link: "/management",
        icon: "mdi-account-edit"
        });
    }
  },
  methods:{
    goToSupport(){
      this.$router.push("/help");
    }
  },
  
};
</script>
<style scoped>
.v-divider{
  margin: 0
}

.theme--dark.v-list-item__title {
  font-weight: 400;
}

.theme--dark.v-list-item--active {
  background-color: #1F1F1F;
  opacity: 1;
}

:deep .theme--light.v-list-item__title {
  font-weight: 600;
}

.v-list .v-list-group__header.v-list-item--active {
  color: #000 !important;
}

.theme--light.v-list-item--active {
  background-color: var(--motiverse-primary);
  opacity: 1;
}

.theme--light.v-list-item--active > .v-list-item__title {
  font-weight: 700;
}

</style>